export { __decorate as _ } from "tslib";
